import { $Color } from '@suntex.core/types';
import { $GradeLevel, $LearningStage } from '@suntex.fim/enums';

import { NodeModel } from '../../../types';

import { modulesNode } from './modules';

const title = 'Stages of Learning';
const shortTitle = 'SoL';

export const stagesOfLearningNode: NodeModel = {
  tag: 'stages-of-learning',
  alias: ['sol'],
  label: 'Stages of\nLearning',
  info: {
    title: title,
  },
  color: $Color.from('#5645da'),
  layout: 'levels',
  children: $GradeLevel.describeAll().map<NodeModel>((level) => {
    const levelTitle = `${shortTitle} — ${level.label}`;
    return {
      tag: level.slug,
      icon: {
        text: level.symbol,
      },
      label: level.label,
      info: {
        title: levelTitle,
      },
      recursiveLogic: 'AND',
      color: level.color,
      layout: 'vertical',
      children: $LearningStage.describeAll().map<NodeModel>((stage) => {
        const stageTitle = `${shortTitle} — ${level.label}, Stage ${stage.value}`;
        return {
          tag: stage.slug,
          icon: `stages-of-learning/${stage.slug}`,
          label: {
            aria: stageTitle,
          },
          info: {
            title: stageTitle,
            summary: `"${stage.label}!" (${stage.instructional})`,
          },
          recursiveLogic: 'AND',
          color: stage.color,
          layout: 'clock',
          filterTagPath: `grade:${level.value}/sol:${stage.value}`,
          filterRoot: modulesNode,
        };
      }),
    };
  }),
};
